export class savemonitortBO {
    id: string;
    colorcode: string;
    notes: string;
}

export class ColorNoteBO {
    monitorId: string;
    colorName: string;
    colorNotes: string;
    colorCode : string;
}

export class GetMonitorBO {

    role: string;
    user: string | null;

    searchColumn: string;
    searchText: string;
    userId: string | null;
    agencyId: string | null;
    locationId: string | null;
    currentpageno: number = 1;
    orderType: string = "asc";
    pageitem: number = 10;
    orderColumn: string = "colorName";
    type: string = "string";
    field: string = "colorName";
    value: string = "";
    operator: string = "startswith";
    matchCase: boolean = false;
}
export class CLientMonitorBO {
    clientId: string;
    monitorId: string;
}